import { clearTimeouts, engine as anime } from "../../../../../animations";
import { getTemplateDurationOveride } from "../../../../shared/utils/timeline"

const timeouts = [];

const main = (props) => {
    const timeouts = [];
    const { id, format, templateName, data } = props;

    const timeline = anime.timeline();

    const templateDuration = getTemplateDurationOveride({
        apiSetup: props?.apiSetup,
        tournamentId: props?.data?.event?.competitionId,
        fallback:
            _.find(props?.data?.data?.options, { id: "videoduration" })?.value || 0,
        templateName,
        event: data?.event
    });

    $(`#${id} .ant-progress-bg`).css("width", "100%");
    $(`#${id} .ant-progress-bg`).css(
        "transition-duration",
        `${templateDuration}s`,
    );

    $(
        `#${id} #${id} .table-row, #${id} .score-container`,
    ).css("opacity", 0);
    $(`#${id} .competition-positioner`).css("opacity", 0);


    anime({
        targets: `#${id} .main-header`,
        easing: "easeOutQuint",
        duration: 1000, // total duration (can adjust)
        delay: 400,
        keyframes: [
            // 1️⃣ Start large and green
            { scale: 3.8, color: '#E1FF57', duration: 0 },

            // 2️⃣ Gradually shrink to 500px while turning white
            { scale: 1.2, color: '#ffffff', duration: 500, easing: 'easeOutQuad' },

            // 3️⃣ Stay white for 200ms (pause)
            { scale: 1.2, color: '#ffffff', duration: 200 },

            // 4️⃣ Gradually go to final size and return to green
            { scale: 1, color: '#E1FF57', duration: 300, easing: 'easeOutQuad' }
        ]
    });

    anime({
        targets: [`#${id} .teams-block .matchday-team-logo-container`],
        duration: 1000,
        easing: "easeOutQuint",
        keyframes: [
            // 1️⃣ Start large and green
            { scale: 0, duration: 0 },

            // 2️⃣ Gradually shrink to 500px while turning white
            { scale: 1.5, duration: 500, easing: 'easeOutQuad' },

            // 3️⃣ Stay white for 200ms (pause)
            { scale: 1.5, duration: 200 },

            // 4️⃣ Gradually go to final size and return to green
            { scale: 1, duration: 300, easing: 'easeOutQuad' }
        ],
        delay: 500,
    });

    anime({
        targets: [`#${id} .matchday-competition-logo, #${id} .team-vs, #${id} .matchday-week`],
        duration: 400,
        easing: "easeOutQuint",
        opacity: [0, 1],
        delay: 600,
    });

    anime({
        targets: [`#${id} .gameInfo`],
        duration: 800,
        easing: "easeOutQuint",
        translateX: [-2000, 0],
        opacity: [1, 1],
        delay: 800,
    });

    anime({
        targets: [`#${id} .venue-container`],
        duration: 800,
        easing: "easeOutQuint",
        translateX: [-2000, 0],
        opacity: [1, 1],
        delay: 900,
    });

    anime({
        targets: [`#${id} .score-container`],
        duration: 900,
        easing: "easeOutQuint",
        translateX: [-2000, 0],
        opacity: [1, 1],
        delay: 900,
    });

    return {
        timeline: [],
        timeouts,
    };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
    const { timeouts } = animationReturn;
    clearTimeouts(timeouts);
};

export default main;
